<template>
    <LangSwitch :lang="appStore.locale" :lang-options="localeOptions" :tooltip-content="''" @change-lang="changeLocale">
        <!-- <SvgIcon localIcon="language" class="text-black text-36px" /> -->
         <div class="flex items-center">
            {{ curLanguage }}
            <SvgIcon icon="mdi:language" class="text-black ml-2" />

         </div>
    </LangSwitch>
</template>

<script setup lang="ts">
import { computed } from 'vue';

import { LangSwitch } from '@yammii/materials';
import { useAppStore } from '@/store/modules/app';

defineOptions({ name: 'LangSwitchWrapper' });
const appStore = useAppStore();

const { localeOptions, changeLocale } = appStore;
const curLanguage = computed(() => {
    return localeOptions.find((item) => item.key === appStore.locale)?.label;
});

</script>

<style lang="scss" scoped></style>